// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Features Glass Styles
   ========================================== */

.features {
  padding: 6rem 1.5rem 4rem 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.features-header h2 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.features-header p {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 3rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.75rem;
  margin-bottom: 4rem;
}

.feature-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 2.25rem 1.5rem;
  transition: all 0.35s ease;
}

.feature-card:hover {
  transform: translateY(-6px);
  border-color: var(--border-glass-hover);
  box-shadow: var(--shadow-lg), var(--shadow-glow);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 1.25rem;
}

.feature-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.feature-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.features-cta {
  background: var(--grad-surface);
  border: 1px solid var(--border-glass);
  padding: 3.5rem 2rem;
  border-radius: var(--radius-lg);
  max-width: 800px;
  margin: 0 auto;
}

.features-cta h3 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.75rem;
}

.features-cta p {
  color: var(--text-muted);
  margin-bottom: 1.75rem;
}

.cta-btn {
  padding: 0.85rem 2rem;
  font-size: 1rem;
  font-weight: 700;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
  transition: all 0.3s ease;
}

.cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Features.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":["/* ==========================================\n   Kubersetu Features Glass Styles\n   ========================================== */\n\n.features {\n  padding: 6rem 1.5rem 4rem 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.features-header h2 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.features-header p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 3rem;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.75rem;\n  margin-bottom: 4rem;\n}\n\n.feature-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 2.25rem 1.5rem;\n  transition: all 0.35s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-6px);\n  border-color: var(--border-glass-hover);\n  box-shadow: var(--shadow-lg), var(--shadow-glow);\n}\n\n.feature-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.feature-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.feature-card p {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.features-cta {\n  background: var(--grad-surface);\n  border: 1px solid var(--border-glass);\n  padding: 3.5rem 2rem;\n  border-radius: var(--radius-lg);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.features-cta h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n}\n\n.features-cta p {\n  color: var(--text-muted);\n  margin-bottom: 1.75rem;\n}\n\n.cta-btn {\n  padding: 0.85rem 2rem;\n  font-size: 1rem;\n  font-weight: 700;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);\n  transition: all 0.3s ease;\n}\n\n.cta-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
